// import { PRODUCTION, DEVELOPMENT, API_DEV_URL } from './const';

import { API_DEV_URL, ENVIROMENT } from "../utils/enum";

const { DEVELOPMENT, PRODUCTION } = ENVIROMENT

export function baseUrl() {
    const REACT_ENV = process.env.REACT_APP_NODE_ENV;
    const API_URL = !!process.env.REACT_APP_API_BASE_URL && process.env.REACT_APP_API_BASE_URL !== '' ? process.env.REACT_APP_API_BASE_URL : '';
    if ((REACT_ENV)) {
        switch (REACT_ENV) {
            case DEVELOPMENT:
                return API_URL;
            case PRODUCTION:
                return API_URL;
            default:
                return API_URL;
        }
    } else {
        return API_DEV_URL
    }
};

export const getApiUrl = (path) => {
    return `${baseUrl()}`
}
